import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { maxFlightCountForMc } from '../../constants/common.constants';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const updateAirportsFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  const airports = retrieveSearchData.airports;
  updatedBookWidgetFields = {
    ...updatedBookWidgetFields,
    airportsField: {
      ...updatedBookWidgetFields.airportsField,
      airports,
      showAddFlightBtn: airports.length < maxFlightCountForMc,
      showRemoveFlightBtn: airports.length > 2
    }
  };

  return updatedBookWidgetFields;
};
